import Pino from 'pino';

export const logger = Pino({
    level: 'info',
    formatters: {
        level(label) {
            return { severity: label.toUpperCase() }; // GCP prefers "severity"
        },
    },
    timestamp: Pino.stdTimeFunctions.isoTime,
});
